import React from 'react';

interface StatusBarProps {
  title?: string;
  className?: string;
}

const StatusBar: React.FC<StatusBarProps> = ({ title = 'The Book of Wisdom', className = '' }) => {
  return (
    <div className={`sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200 lg:hidden px-4 h-12 flex items-center justify-between shadow-sm safe-area-top ${className}`}>
        <div className="font-semibold text-slate-800 truncate">
            {title}
        </div>
        <div className="flex items-center space-x-2">
            {/* Placeholder for status icons or actions like connection status */}
            <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" title="Connected" />
        </div>
    </div>
  );
};

export default StatusBar;
